(function() {

  RS.Modules.PredictiveSearch = {

    config: null,
    timeoutId: null,
    catreqId: null,
    prodreqId: null,
    topCategories: {},
    refSearchForm: null,
    refSearchTerm: null,
    refResultProd: null,
    refResultHint: null,
    refPredictiveSearch: null,
    refSearchHint: null,
    predictivesearchLink: null,
    topCatName: null,


    keysearch: function() {
      var psearch = RS.Modules.PredictiveSearch;

      psearch.refSearchTerm.keydown(function(e) {

        // abort Ajax call
        if(RS.Modules.PredictiveSearch.catreqId){
          RS.Modules.PredictiveSearch.catreqId.abort();
        }
        if(RS.Modules.PredictiveSearch.prodreqId){
          RS.Modules.PredictiveSearch.prodreqId.abort();
        }

        // clear timer
        clearTimeout(RS.Modules.PredictiveSearch.timeoutId);

        var escapeCode = e.charCode || e.keyCode;
        RS.Modules.PredictiveSearch.keyboardNavigation(escapeCode);

      });

      psearch.refSearchTerm.focus(function(e) {
        // text style for differences in strut and seam headers
        $(this).css('color', '#000000');
      });

      psearch.refSearchTerm.keyup(function(e) {
        if (!RS.Modules.SearchHistory.isSearchHistoryItemHovered()) { // Don't trigger when user presses enter on Search History item
          if (e.keyCode == 13){
            RS.Modules.PredictiveSearch.search();
          }
          else{
            RS.Modules.PredictiveSearch.timeoutId = setTimeout(RS.Modules.PredictiveSearch.search, RS.Modules.PredictiveSearch.maxDelay);
          }
        }
      });

      psearch.refSearchForm.mouseleave(function() {
        RS.Modules.PredictiveSearch.refPredictiveSearch.hide();
        RS.Modules.PredictiveSearch.unbindResultListeners();
      });

      psearch.refSearchForm.focus(function() {
        RS.Modules.PredictiveSearch.search()
      })

    },

    trimSpaces: function(sreachString){
      if (sreachString != null) {
        sreachString = sreachString.replace ( /^\s+/g, "" );// strip leading
        sreachString = sreachString.replace ( /\s+$/g, "" );// strip trailing
        sreachString = sreachString.replace ( /\s+/g, " " );// replace multiple with single
        }
      return sreachString;
    },

    getSearchCriteria: function(locale, advancedSearch) {
        var criteria = '&locale=' + locale + '&advancedPredictiveSearchEnabled=' + advancedSearch;

        return (RS.Modules.PredictiveSearch.config.restrictedCustomer) ?  criteria += "&soldTo=" + RS.Modules.PredictiveSearch.config.restrictedCustomer : criteria;
    },

    getTopProductsURL: function(locale, categoryURL) {
        var url ='/predictivesearch/top-products/locales/' + locale + '/categories' + categoryURL;

        return (RS.Modules.PredictiveSearch.config.restrictedCustomer) ?  url += "?soldTo=" + RS.Modules.PredictiveSearch.config.restrictedCustomer : url;
    },
    search: function() {
      var url = '/predictivesearch/catSearch?searchTerm=', type = 'GET', criteria, searchTerm;

      criteria = RS.Modules.PredictiveSearch.getSearchCriteria(RS.Modules.PredictiveSearch.config.srchLocale, RS.Modules.PredictiveSearch.config.advsrchEnabled);

      searchTerm = RS.Modules.PredictiveSearch.trimSpaces(RS.Modules.PredictiveSearch.refSearchTerm.val());

      RS.Modules.PredictiveSearch.refPredictiveSearch.hide();

      // no search less than 3 characters
      if (typeof RS.Modules.PredictiveSearch.refSearchTerm === 'undefined') {
        return;
      }

      if (searchTerm.length <= RS.Modules.PredictiveSearch.config.searchTermMinLength) {
        return;
      }

      // return last search if it is the same
      if (RS.Modules.PredictiveSearch.refSearchTerm.data('searchTerm') === searchTerm) {
        RS.Modules.PredictiveSearch.refPredictiveSearch.show(true);
        return;
      }

      RS.Modules.PredictiveSearch.catreqId = RS.Utils.AjaxService.processXHR(url + searchTerm + criteria, type, 5000, RS.Modules.PredictiveSearch.updateSearchResult);

    },

    updateSearchResult: function(resultData) {
      var resultFormatted = '';
      var formattedItem = '';
      var elementNo = 0;

      // store search term
      RS.Modules.PredictiveSearch.refSearchTerm.data('searchTerm', RS.Modules.PredictiveSearch.trimSpaces(RS.Modules.PredictiveSearch.refSearchTerm.val()));

      // reset search result
      RS.Modules.PredictiveSearch.unbindResultListeners();
      RS.Modules.PredictiveSearch.refResultHint.html('');
      RS.Modules.PredictiveSearch.refResultProd.html('');

      // no data
      if (!resultData) {
        return;
      }
      resultData = JSON.parse(resultData);

      for (var group in resultData) {
        if (resultData.hasOwnProperty(group)) {
          resultFormatted = resultFormatted + '<li class="section-title">' + group + '</li>';
          var items = resultData[group];
          for (var item in items) {
            var url = items[item];
            if(url.indexOf('/web') === -1){
              if(url.indexOf("?") > -1){
                url = '/web' + url + '&sra=p';
              } else {
                url = '/web' + url + '?sra=p';
              }
            }
            var catName = item.replace(/\'/g, "");
            if (items[item].indexOf("/c/") === 4) {
              if (elementNo === 0) {
                //first element
                RS.Modules.PredictiveSearch.loadTopCategory(url, catName);
              }
            }
            formattedItem = item.replace(new RegExp('(' + RS.Modules.PredictiveSearch.refSearchTerm.val() + ')', 'gi'), "<b>$1</b>");
            resultFormatted = resultFormatted + "<li><a data-category='" + catName + "' onmouseenter='RS.Modules.PredictiveSearch.getTopProducts(this)' id=" + (elementNo++) + " href='" + url + "'>" + formattedItem + "</a></li>";
          }

        }
      }

      //update html
      RS.Modules.PredictiveSearch.refPredictiveSearch.show(true);
      RS.Modules.PredictiveSearch.refResultHint.show(true).html(resultFormatted);
      RS.Modules.PredictiveSearch.bindResultListeners();
    },

    loadTopCategory: function(catURL, catName) {
      var type = 'GET';

      RS.Modules.PredictiveSearch.unbindTopProductListeners();

      if (catName.lastIndexOf('>') >= 0) {
        RS.Modules.PredictiveSearch.topCatName = catName.substring(catName.lastIndexOf('>')+1);
      } else {
        RS.Modules.PredictiveSearch.topCatName = catName;
      }

      // locale from system var
      var url = RS.Modules.PredictiveSearch.getTopProductsURL(RS.Modules.PredictiveSearch.config.srchLocale, catURL.replace(/\/web|\?sra=p/g, ""));

      // no advanced search enabled
      if ( !RS.Modules.PredictiveSearch.config.advsrchEnabled ){
        return;
      }

      // last cat name
      if (catName.lastIndexOf(">") >= 0) {
        catName = catName.substring(catName.lastIndexOf(">") + 1);
      }

      // pick from cache if available
      if (RS.Modules.PredictiveSearch.topCategories[url] != null) {
        RS.Modules.PredictiveSearch.refResultProd.show(true).html(RS.Modules.PredictiveSearch.topCategories[url]);
        RS.Modules.PredictiveSearch.bindTopProductListeners();
        return;
      }

      RS.Modules.PredictiveSearch.prodreqId = RS.Utils.AjaxService.processXHR(url, type, 5000, RS.Modules.PredictiveSearch.updateAdvancedSearchResult);
    },

    unbindResultListeners: function() {
      $('.search-hint li a[data-category]').off('click');
    },

    bindResultListeners: function() {
      $('.search-hint').on('click', 'li a[data-category]', function(event) {
        var category = $(event.currentTarget).data('category');
        var linkHref = $(event.currentTarget).prop('href');

        // Don't add events for Brand links as the Brand page is old so won't process it
        if(linkHref && linkHref.indexOf('/b/') < 0) {
          RS.Modules.Analytics.addDeferredSearchEvent('header', category, 'Predictive', linkHref);
        }
      });
    },

    unbindTopProductListeners: function() {
      $('.search-prod li a').off('click');
    },

    bindTopProductListeners: function() {
      $('.search-prod').on('click', 'li a', function(event) {
        var productName = $(event.currentTarget).data('name');
        var linkHref = $(event.currentTarget).prop('href');
        RS.Modules.Analytics.addDeferredSearchEvent('header', productName, 'Predictive', linkHref);
      });
    },

    updateAdvancedSearchResult: function(resultData) {
      var prodList = '<li class="prod-cat">' + RS.Modules.PredictiveSearch.config.tpTitle + ' ' + RS.Modules.PredictiveSearch.config.tpSubTitle + ' ' + RS.Modules.PredictiveSearch.topCatName + '</li>';
      var catURL = this.url;

      // no data
      if (!resultData || !resultData.hasOwnProperty('products')) {
        return;
      }

      // build advanced search
      for (var i = 0; i < resultData.products.length; i++) {
        prodList = prodList + '<li><a data-name="'+ resultData.products[i].longDescription +'" href="/web/p/products/' + resultData.products[i].productNumber +
        '/?tpr=' + (i + 1) + '"><div class="prod-img"><img src="' + resultData.products[i].imagePath +
        '"></div><div class="prod-name">' + resultData.products[i].longDescription +
        '<div class="prod-brand">' + resultData.products[i].brandName + '</div></div></a></li>';
      }

      // store the result
      RS.Modules.PredictiveSearch.topCategories[catURL] = prodList;
      RS.Modules.PredictiveSearch.refResultProd.show(true).html(prodList);
      RS.Modules.PredictiveSearch.bindTopProductListeners();
    },

    getTopProducts: function(elmAnchor) {
      var catURL = elmAnchor.getAttribute('href');
      var catName = elmAnchor.getAttribute('data-category');
      if (catURL.indexOf("/c/") > -1) {
        // only if it is a category
        if (catName.lastIndexOf(">") >= 0) {
          catName = catName.substring(catName.lastIndexOf(">") + 1);
        }
        // call the top category
        RS.Modules.PredictiveSearch.loadTopCategory(catURL, catName);
      } else {
        // no category
        RS.Modules.PredictiveSearch.refResultProd.hide();
      }
    },

    keyboardNavigation: function(keyCode) {
      var currentId = 0;

      if ($('.predictive-search').is(":hidden")) {
        return;
      }

      switch (keyCode) {

        case 27:
          // esc key
          RS.Modules.PredictiveSearch.refSearchTerm.val('');
          break;

        case 38:
          // up arrow
          if ($('.search-hint li .textRed').length > 0) {
            currentId = parseInt($('.search-hint li .textRed')[0].id);
            //unset active link
            $('.search-hint li #' + currentId).toggleClass('textRed');
            currentId--;
            //set active link
            $('.search-hint li #' + currentId).toggleClass('textRed');
            RS.Modules.PredictiveSearch.predictivesearchLink = $('.search-hint li #' + currentId)[0].href;
          }
          break;

        case 40:
          // down arrow
          if ($('.search-hint li .textRed').length == 0) {
            // start with first
            $('.search-hint li #0').toggleClass('textRed');
          } else {
            currentId = parseInt($('.search-hint li .textRed')[0].id);
            //unset active link
            $('.search-hint li #' + currentId).toggleClass('textRed');
            currentId++;
            //set active link
            $('.search-hint li #' + currentId).toggleClass('textRed');
            RS.Modules.PredictiveSearch.predictivesearchLink = $('.search-hint li #' + currentId)[0].href;
          }
          break;

        case 13:
          //enter key
          window.location.href = RS.Modules.PredictiveSearch.predictivesearchLink;
          break;

      }

    },

    init: function() {

      var _obj = RS.Modules.PredictiveSearch;
      // only if search config exists
      if (typeof searchConfig !== 'undefined') {
        _obj.refSearchForm = $('#searchForm');
        _obj.refSearchTerm = $('#searchTerm');
        _obj.refResultProd = $('#js-search-prod');
        _obj.refResultHint = $('#js-search-hint');
        _obj.refPredictiveSearch = $('#js-predictive-search');
        _obj.refSearchHint = $('#js-search-hint');
        _obj.config = searchConfig;
        RS.Modules.PredictiveSearch.keysearch();
      }

    }
  }

}());

(function() {
  //Initalise the Check term
  RS.Modules.PredictiveSearch.init();
}());


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/universalheader/predictivesearch.js
// module id = 328
// module chunks = 5